<div [ngClass]="flow">
  <button mat-icon-button color="primary" [matMenuTriggerFor]="projectList" [disabled]="disabledProject">
    <mat-icon class="example-icon">
      assignment
    </mat-icon>
  </button>
  <button mat-icon-button [matMenuTriggerFor]="menuProfile">
    <mat-icon color="primary" class="example-icon">
      account_circle
    </mat-icon>
  </button>
  <button mat-icon-button [matMenuTriggerFor]="language"
    style="margin-top: -3px;">
    <img matTooltip="{{'selectLanguage'|translate}}"
      src="assets/icon/flags/{{iconLanguage+'.svg'}}"
      color="primary"
      class="img-icon">
  </button>
</div>

<mat-menu #projectList="matMenu">
  @for (project of allProject; track project.objectId) {
    <button mat-menu-item (click)="selectProject(project)"
      [ngClass]="{'background-default-select':project|transformValueByPredicateFunction:isEqualsProjectPredicate:currentProject}"
      >
      <span>{{ project.name }}</span>
    </button>
  }
</mat-menu>
<mat-menu #menuProfile="matMenu">
  <p [disabled]="true" mat-menu-item>{{ 'welcome' | translate:{name: nameUser} }}</p>
  <a mat-menu-item [routerLink]="'/user/account'">
    <mat-icon>edit</mat-icon>
    <span>{{ 'edit_profile' | translate }}</span>
  </a>
  @if (isSystemAdmin) {
    <app-huna-load-content [loading]="loadInviteUser" type="mat-icon-button">
      <a mat-menu-item (click)="inviteUser()">
        <mat-icon>person_add</mat-icon>
        <span>{{ 'person_add' | translate }}</span>
      </a>
    </app-huna-load-content>
  }
  <a mat-menu-item (click)="logout()">
    <mat-icon>exit_to_app</mat-icon>
    <span>{{ 'exit' | translate }}</span>
  </a>
  <!--    <div>-->
  <!--        <button mat-menu-item (click)="darkModeChangeValue(!darkModeOn);">-->
  <!--            <mat-slide-toggle style="opacity: 1!important;"-->
<!--                              [checked]="darkModeOn">{{'darkMode'|translate}}</mat-slide-toggle>-->
<!--        </button>-->
<!--    </div>-->
<div class="flex-end-center">
  <img src="assets/icon/hamburgerNavbar/version.png" class="img-icon-M">
  <span style="margin: 0 10px;font-weight: 500;" class="text-color-default">{{ versioneSoftware }}</span>
</div>
</mat-menu>
<mat-menu #language="matMenu">
  <div mat-menu-item class="flex-center-center-important" (click)="setLanguage('it')" matTooltip="Italiano">
    <img src="assets/icon/flags/it.svg" class="img-icon">
  </div>
  <div mat-menu-item class="flex-center-center-important" matTooltip="Català" (click)="setLanguage('ca')">
    <img src="assets/icon/flags/ca.svg" class="img-icon">
  </div>
  <div mat-menu-item class="flex-center-center-important" matTooltip="Español" (click)="setLanguage('es')">
    <img src="assets/icon/flags/es.svg" class="img-icon">
  </div>
  <div mat-menu-item class="flex-center-center-important" matTooltip="English" (click)="setLanguage('en')">
    <img src="assets/icon/flags/en.svg" class="img-icon">
  </div>
  <div mat-menu-item class="flex-center-center-important" matTooltip="France" (click)="setLanguage('fr')">
    <img src="assets/icon/flags/fr.svg" class="img-icon">
  </div>
</mat-menu>
